import { ILocation, ILocationGroup, IViewLocationList } from 'src/interfaces';

export const createBannerAndMessageConfig = (
  isBannerEnabled: boolean,
  isMessagingEnabled: boolean,
) => {
  return {
    cod: {
      codSetting: {
        topMessage: {
          hideRmhcMessage: !isMessagingEnabled,
        },
      },
      confirmSetting: {
        header: {
          review: {
            banner: {
              active: isBannerEnabled,
            },
          },
        },
      },
    },
  };
};

export const mergeConfigWithBannerAndMessage = (
  existingConfig: Record<string, any>,
  isBannerEnabled: boolean,
  isMessagingEnabled: boolean,
): Record<string, any> => {
  const bannerAndMessageConfig = createBannerAndMessageConfig(
    isBannerEnabled,
    isMessagingEnabled,
  );

  return {
    ...existingConfig,
    cod: {
      ...(existingConfig.cod ?? {}),
      ...bannerAndMessageConfig.cod,
    },
  };
};

export const findLocationGroupByChannel = (
  locationGroups: ILocationGroup[] = [],
  channelName: string,
) => {
  return locationGroups.find((item) => item.channel_name === channelName);
};

export const findLocationGroupByIDs = (
  locationGroups: ILocationGroup[],
  Ids: number[],
) => {
  return locationGroups.find((item) => Ids.includes(item.id));
};

export const convertToViewLocationList = (
  loc: ILocation,
): IViewLocationList => ({
  id: `${loc.location_code}-${loc.location_group_id?.[0] ?? 'unknown'}`,
  name: loc.hq?.name ?? '',
  has_assembly_variation: false,
  has_override: loc.has_override ?? false,
  address_line_1: loc.hq?.address_line_1 ?? '',
  address_line_2: loc.hq?.address_line_2 ?? '',
  city: loc.hq?.city ?? '',
  country: loc.hq?.country ?? '',
  postal_code: loc.hq?.postal_code ?? '',
  region: loc.hq?.region ?? '',
  store_number: loc.hq?.store_number ?? '',
  timezone: loc.hq?.timezone ?? '',
  zone: loc.hq?.zone ?? '',
  subzone: loc.hq?.subzone ?? '',
  location_code: loc.location_code,
  config: loc.config,
  channels: loc.hq?.channels ?? [],
  location_tag_id: loc.location_tag_id,
  locationTags: loc.locationTags,
  location_owner_tag_id: loc.location_owner_tag_id,
  locationOwnerTags: loc.locationOwnerTags,
});
